import { Button, IconButton, Menu, MenuItem, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import React from 'react';
import logo from '../../../../assets/axcess logo_primary.svg';
import { Box } from '../../../UI';
import Meta from '../../../UI/Meta';

export default function Header({ data }) {
	const classes = useStyles();
	const { id } = data;
	const [anchorEl, setAnchorEl] = React.useState(null);
	const isMenuOpen = Boolean(anchorEl);
	const [status, setStatus] = React.useState('Standard');

	const handleProfileMenuOpen = event => {
		setAnchorEl(event.currentTarget);
	};
	const handleMenuClose = () => {
		setAnchorEl(null);
	};
	const handleStatus = value => {
		setStatus(value);
		handleMenuClose();
	};
	const renderMenu = (
		<Menu
			anchorEl={anchorEl}
			anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
			id={'menu'}
			keepMounted
			transformOrigin={{ vertical: 'top', horizontal: 'right' }}
			open={isMenuOpen}
			onClose={handleMenuClose}
		>
			<MenuItem onClick={() => handleStatus('Standard')}>Standard</MenuItem>
			<MenuItem onClick={() => handleStatus('Premium')}>Premium</MenuItem>
			<MenuItem onClick={() => handleStatus('Bespoke')}>Bespoke</MenuItem>
		</Menu>
	);
	return (
		<Box width="100%" display="flex" flexDirection={['column', 'column', 'column', 'row']} justifyContent="space-between">
			<Box display="flex" flexDirection="row" mb={['1rem', '1rem', '1rem', '0']}>
				<div className={classes.chip}>
					<Box mr=".5rem" height="15px">
						<img src={logo} alt="aXcess logo" className={classes.logo} />
					</Box>
					<Typography variant="body1" className={classes.chipText}>
						<strong>{status} Model</strong>
					</Typography>
					<IconButton
						edge="end"
						color="inherit"
						aria-label="menu"
						aria-controls={'Menu'}
						aria-haspopup="true"
						onClick={handleProfileMenuOpen}
						style={{ padding: 0, color: '#b60037' }}
					>
						<ArrowDropDownIcon />
					</IconButton>
					{renderMenu}
				</div>
				<Box ml="1rem">
					<Button variant="contained" color="primary">
						Save
					</Button>
				</Box>
				<Box ml="1rem">
					<Button variant="contained" color="primary">
						Upgrade
					</Button>
				</Box>
			</Box>
			<Meta id={id} />
		</Box>
	);
}

const useStyles = makeStyles(theme => ({
	chip: {
		background: '#eee',
		padding: '.5rem 1rem',
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: '50px',
	},
	logo: {
		height: '15px',
	},
	chipText: {
		color: '424242',
	},
}));
